<script setup lang="ts">
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    breadcrumbs?: any;
  }>(),
  {
    breadcrumbs: [],
  }
);
let { breadcrumbs: initialBreadcrumbs } = useBreadcrumbs();
const breadcrumbs = computed(() =>
  props.breadcrumbs?.length > 0 ? props.breadcrumbs : initialBreadcrumbs.value
);

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);

const unifiedBreadcrumbs = computed(() => {
  const homeBreadcrumb = {
    name: t("home"),
    path: "/",
  };

  return breadcrumbs.value && breadcrumbs.value.length > 0
    ? [homeBreadcrumb, ...breadcrumbs.value]
    : homeBreadcrumb;
});
</script>
<template>
  <div class="breadcrumb hidden lg:block" v-if="unifiedBreadcrumbs.length < 3">
    <div class="container py-6">
      <nav class="flex justify-end">
        <ul class="flex font-redit_sans text-lg gap-3">
          <template
            v-for="(breadcrumb, index) in unifiedBreadcrumbs"
            :key="breadcrumb.path"
          >
            <li
              v-if="
                unifiedBreadcrumbs.length < 3 ||
                (unifiedBreadcrumbs.length >= 3 && index !== 1)
              "
            >
              <template v-if="breadcrumb.path">
                <NuxtLink
                  v-if="breadcrumb.path"
                  :to="formatLink(breadcrumb.path)"
                >
                  {{ breadcrumb.name }}
                </NuxtLink>
              </template>
              <template v-else>
                <span>
                  {{ breadcrumb.name }}
                </span>
              </template>
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </div>
</template>
